import { render } from "./GalleryGrid.vue?vue&type=template&id=05f731d2&scoped=true"
import script from "./GalleryGrid.vue?vue&type=script&lang=js"
export * from "./GalleryGrid.vue?vue&type=script&lang=js"

import "./GalleryGrid.vue?vue&type=style&index=0&id=05f731d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f731d2"]])

export default __exports__